import React from 'react';
import PropTypes from 'prop-types';

import './TooltipMobile.scss';

export default function TooltipMobile(props) {
  const { text, showTooltip, handleTooltipVisibility } = props;

  return showTooltip ? (
    <div className="c-tooltip-mobile">
      <div className="c-tooltip-mobile__text">{text}</div>
      <i
        onClick={handleTooltipVisibility()}
        className="material-icons"
        data-test-tooltip="clear-icon"
      >
        clear
      </i>
    </div>
  ) : null;
}

TooltipMobile.propTypes = {
  text: PropTypes.string,
  showTooltip: PropTypes.bool,
  handleTooltipVisibility: PropTypes.func,
};
